// extracted by mini-css-extract-plugin
export default {"card":"styles_card__4L4q1","header":"styles_header__ZWpiu","close":"styles_close__xOwjK","table":"styles_table__G5ncr"};